import { createContext } from 'react'

import type { OnboardingStore } from './OnboardingStore'

export const OnboardingContext = createContext<OnboardingStore | undefined>(
    undefined,
)
